import { render, staticRenderFns } from "./VideosEstadisticas.vue?vue&type=template&id=8666f2b6&scoped=true&"
import script from "./VideosEstadisticas.vue?vue&type=script&lang=js&"
export * from "./VideosEstadisticas.vue?vue&type=script&lang=js&"
import style0 from "./VideosEstadisticas.vue?vue&type=style&index=0&id=8666f2b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8666f2b6",
  null
  
)

export default component.exports